import React, { useState } from "react";
import "./FAQ.css";

const faqData = [
  {
    question: "Which documents are required to prepare my U.S. tax return?",
    answer:
      "You should gather your W-2s, 1099 forms, the previous year’s tax filing, receipts or statements for deductions such as mortgage interest and charitable donations, and any other income records.",
  },
  {
    question: "Do I still need to file U.S. taxes while living abroad?",
    answer:
      "Yes. U.S. citizens and green card holders must file taxes even if they live outside the country. We can guide you through foreign income rules and treaty benefits to ensure compliance.",
  },
  {
    question: "How do you help freelancers and self-employed individuals?",
    answer:
      "We provide specialized tax services for independent professionals—covering business expense deductions, quarterly tax planning, and identifying every credit you are entitled to.",
  },
  {
    question: "What’s the typical turnaround time for filing my taxes?",
    answer:
      "Most tax returns are prepared and filed within a few business days. The exact timing depends on the complexity of your finances, but we always focus on speed and accuracy.",
  },
  {
    question: "Am I eligible for education-related tax credits?",
    answer:
      "Yes. Options like the American Opportunity Credit and the Lifetime Learning Credit may apply. We’ll evaluate your situation and make sure you claim the maximum benefits allowed.",
  },
  {
    question: "How does foreign income affect my U.S. taxes?",
    answer:
      "All worldwide income must be reported to the IRS. Depending on your case, you may qualify for the Foreign Earned Income Exclusion or Foreign Tax Credit to reduce double taxation.",
  },
  {
    question: "What steps can I take to avoid late-filing penalties?",
    answer:
      "Filing on time or requesting an extension is key. If you owe taxes, paying as soon as possible helps minimize interest and late fees.",
  },
  {
    question: "When is the U.S. tax filing deadline?",
    answer:
      "The regular deadline is April 15th each year. Expats usually get an automatic extension until June 15th, but any payments owed are still due in April.",
  },
  {
    question: "Can you represent me if I get audited by the IRS?",
    answer:
      "Absolutely. We assist with IRS audits by organizing your documents, responding to inquiries, and guiding you until the case is resolved.",
  },
  {
    question: "Is it possible to request an extension for tax filing?",
    answer:
      "Yes. You can file for a six-month extension to submit your return. However, the extension only applies to filing—not to paying taxes due.",
  },
  {
    question: "Do you provide tax planning for upcoming years?",
    answer:
      "Yes, we help you plan ahead by estimating your future tax liability, suggesting strategies for savings, and preventing surprises during filing season.",
  },
  {
    question: "Can you help businesses with tax compliance?",
    answer:
      "We support small businesses and startups with bookkeeping, payroll tax reporting, and corporate tax returns, ensuring compliance while maximizing deductions.",
  },
  {
    question: "Do you work with international students or visa holders?",
    answer:
      "Yes. We assist F1, H1B, and other visa holders with filing requirements, treaty benefits, and tax implications of working or studying in the U.S.",
  },
  {
    question: "What happens if I already missed the tax deadline?",
    answer:
      "If you’ve missed the deadline, you should file as soon as possible. Late filing can be corrected, and penalties may be reduced if handled quickly.",
  },
  {
    question: "Is virtual tax filing an option with your firm?",
    answer:
      "Yes. You can securely upload documents online, consult with us virtually, and have your return filed electronically without needing in-person visits.",
  },
];


const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="faq-container">
      <h1 className="faq-title">Frequently Asked Questions</h1>
      <div className="faq-wrapper">
        {faqData.map((item, index) => (
          <div
            key={index}
            className={`faq-item ${activeIndex === index ? "active" : ""}`}
            onClick={() => toggleFAQ(index)}
          >
            <div className="faq-question">
              <span>{item.question}</span>
              <span className="faq-icon">
                {activeIndex === index ? "▲" : "▼"}
              </span>
            </div>
            <div
              className={`faq-answer ${
                activeIndex === index ? "show" : ""
              }`}
            >
              {item.answer}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQ;
